export enum BetType {
	FPCBFish,
	FPCBCalabash,
	FPCBPrawn,
	FPCBCrab,
	FPCBTiger,
	FPCBRooster,
	FPCBDoubleFishCalabash,
	FPCBDoubleFishPrawn,
	FPCBDoubleFishCrab,
	FPCBDoubleFishTiger,
	FPCBDoubleFishRooster,
	FPCBDoubleCalabashPrawn,
	FPCBDoubleCalabashCrab,
	FPCBDoubleCalabashTiger,
	FPCBDoubleCalabashRooster,
	FPCBDoublePrawnCrab,
	FPCBDoublePrawnTiger,
	FPCBDoublePrawnRooster,
	FPCBDoubleCrabTiger,
	FPCBDoubleCrabRooster,
	FPCBDoubleTigerRooster,
	FPCBAnyTripleColor,
	FPCBAnyTripleSymbol,

	THLBMaxBet,
}